import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['body', 'chevron', 'num']
  static values = { open: Boolean }

  toggle() {
    this.openValue = !this.openValue
    this.bodyTarget.classList.toggle('hidden', !this.openValue)
    this.chevronTarget.style.transform = this.openValue ? 'rotate(180deg)' : ''
    if (this.hasNumTarget) {
      this.numTarget.classList.toggle('text-gray-300', !this.openValue)
      this.numTarget.classList.toggle('text-amber-600', this.openValue)
    }
  }
}
